import { useTypedDispatch, useTypedSelector } from "App/Store";
import { Brackets } from "components/Brackets ";
import { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import { getBracketPreviewDetails } from "redux/action/bracketPreviewAction";

interface UrlParams {
  tournamentId: string;
}

export default function BracketFullScreen() {
  const { tournamentId } = useParams<UrlParams>();
  const location = useLocation();

  const queryParams = new URLSearchParams(location.search);
  const bracketType = queryParams.get("bracketType") || "n";
  const thirdPlaceMatch = queryParams.get("thirdPlaceMatch") || "n";
  const type = queryParams.get("type") || "all";
  const dispatch = useTypedDispatch();

  const { bracketPreview, isLoading: isBracketsLoading } = useTypedSelector(
    (state) => state.bracketPreview
  );

  useEffect(() => {
    if (tournamentId && bracketType) {
      dispatch(
        getBracketPreviewDetails(
          tournamentId,
          bracketType,
          thirdPlaceMatch === "false" ? "n" : "y"
        )
      );
    }
  }, [dispatch, tournamentId, bracketType, thirdPlaceMatch]);

  const isLoading = isBracketsLoading;

  return (
    <div style={{ position: "relative", width: "100%", height: "100vh" }}>
      {!isLoading && bracketPreview ? (
        bracketType !== "Round Robin" ? (
          <Brackets
            brackets={
              type === "all"
                ? bracketPreview?.allTeamPreview
                : bracketPreview?.checkedInTeamPreview
            }
            onMatchClick={() => {}}
          />
        ) : (
          <div>Not Available</div>
        )
      ) : (
        <div style={{ textAlign: "center", paddingTop: "2rem" }}>
          Loading brackets...
        </div>
      )}
    </div>
  );
}
